import { useState } from "react";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import FormButton from "../../../../_shoru_shared_library/components/form/FormButton";
import FormInput from "../../../../_shoru_shared_library/components/form/FormInput";
import { addUnbookedAudition, createAuditionee, getAuditionee } from "../../../../CastingBotFirebase";

function AddBookingTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  // 0 = enter email, 1 = auditionee found, 2 = add auditionee
  const [stage, setStage] = useState(0);
  const [auditionee, setAuditionee] = useState(undefined);

  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [secondName, setSecondName] = useState('');
  const [phone, setPhone] = useState('');
  const [log, setLog] = useState([]);

  const logDisplay = log.map((item, index) => {
    return (
      <p key={index} style={{
        ...{marginTop: '0'},
        ...{marginBottom:'0'},
        ...{color:'#2ecc71'},
        ...{fontSize: '12px'}
      }}>
        {item}
      </p>
    )
  })

  return (
    <SubTabParent passData={props}>
      <SubTabSection title='Add Audition Booking' description='For walk-ins, self-tapes, and shows using external booking systems'>
        <FormInput required trim lowercase title='Email' value={email} setValue={(x) => {setStage(0); setEmail(x); setFirstName(''); setSecondName(''); setPhone('');}} type='text' />

        {stage === 0? (

          <FormButton label='Search' accentColour={props.accentColour} onClick={async() => {
            const emailValue = _validateAndGetEmail(email);
            if (emailValue !== null) {
              await getAuditionee(email, userData.active_organisation_id).then((auditionee) => {
                setAuditionee(auditionee);
                if(auditionee !== null) setStage(1);
                else setStage(2);
              });
            };
          }} />

        ) : stage === 1? (

          <div>
            <FormInput title='Name' value={auditionee.name} disabled />
            <FormButton label='Add Booking' accentColour={props.accentColour} onClick={async() => {
              await addUnbookedAudition(auditionee, userData.active_organisation_id, castingData.uid, setCastingData).then(() => {
                setEmail('');
                setStage(0);
                setLog([('Added booking: ' + email),...log]);
              }, (rejection) => {console.error(rejection); alert('Could not add auditionee')});
            }} />
          </div>

        ) : (
          <div>
            <FormInput required title='First Name' value={firstName} setValue={setFirstName} type='text' />
            <FormInput required title='Second Name' value={secondName} setValue={setSecondName} type='text' />
            <FormInput required title='Phone Number' value={phone} setValue={setPhone} type='text' />
            <FormButton label='Add Booking' accentColour={props.accentColour} onClick={async() => {
              const auditionee = _validateAndGetAuditionee(email, firstName, secondName, phone);
              if(auditionee !== null) {
                await createAuditionee(auditionee, userData.active_organisation_id)
                .then(async(successful) => {
                  if(successful) await addUnbookedAudition(auditionee, userData.active_organisation_id, castingData.uid, setCastingData)
                  .then(() => {
                    setEmail('');
                    setStage(0);
                    setLog([('Added booking: ' + email),...log]);
                  });
                });
              }
            }} />
          </div>

        )}

        {log.length > 0? (
          <div style={{marginTop: '30px'}}>
            {logDisplay}
          </div>
        ) : null}
      </SubTabSection>
    </SubTabParent>
  )

}

export default AddBookingTab;


const _validateAndGetEmail = (email) => {
  if(email === '')
  {
    alert('Email is a required field');
    return null;
  }
  else {
    return email;
  }
}

const _validateAndGetAuditionee = (email, firstName, secondName, phone) => {
  if(email === '' || firstName === '' || secondName === '' || phone === '') {
    alert('All required fields must be filled out');
    return null;
  }
  else {
    return {
      name: (firstName.trim() + ' ' + secondName.trim()),
      uid: Math.random().toString(36).substring(2, 10),
      email: email,
      phone: phone
    }
  }
}